import { render, staticRenderFns } from "./CalendarEventSendReminder.vue?vue&type=template&id=1e8d2d9e&scoped=true&"
import script from "./CalendarEventSendReminder.vue?vue&type=script&lang=ts&"
export * from "./CalendarEventSendReminder.vue?vue&type=script&lang=ts&"
import style0 from "./CalendarEventSendReminder.vue?vue&type=style&index=0&id=1e8d2d9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8d2d9e",
  null
  
)

export default component.exports